var cssClassIdx = 0;
export function getClassId() {
    return cssClassIdx++;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/zrender@5.6.0/node_modules/zrender/lib/svg/cssClassId.js
// module id = null
// module chunks = 